import { createContext, useContext } from "react";
import type Keycloak from "keycloak-js";

const AuthContext = createContext<Keycloak | undefined>(undefined);

export const AuthContextProvider = AuthContext.Provider;

export const useAuthContext = (): Keycloak => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error(
      "useAuthContext must be used within an AuthContextProvider",
    );
  }
  return context;
};
